import { object, string } from 'yup'

export const updateDriverFormSchema = object().shape({
  firstName: string().required('First name is a required field').default(''),
  lastName: string().required('Last name is a required field').default(''),
  address: string().optional().default(''),
  licenseNumber: string().optional().default(''),
  dateOfIssue: string().optional().default(''),
  expiryDate: string().optional().default(''),
  driverReferenceNumber: string().optional().default(''),
  sex: string().optional().default(''),
  licenseClass: string().optional().default(''),
  restrictions: string().optional().default(''),
  dateOfBirth: string().optional().default(''),
  height: string().optional().default(''),
  typeOfLicense: string().optional().default(''),
  citizenshipCountry: string().optional().default(''),
  fastCardNumber: string().optional().default(''),
})
